"use client";

import { FC, useContext } from "react";
import dynamic from "next/dynamic";
import {
    ReferralReportProvider,
    RuntimeConfigContext,
    useFindReferral,
} from "@finbackoffice/site-core";
import { ConfigContextV2 } from "contexts";
import ErrorBoundary from "components/base/error-boundary/ErrorBoundary";
import Loading from "components/base/loading/Loading";
import styles from "./account-referral-container.module.sass";

const BecomeReferral = dynamic(() => import("./become/BecomeReferral"), {
    loading: () => <Loading />,
    ssr: false,
});

const ReferralReport = dynamic(() => import("./report/ReferralReport"), {
    loading: () => <Loading />,
    ssr: false,
});

const AccountReferralModalContent: FC = () => {
    const { slug, loading, findReferral, createReferralLink } = useFindReferral();
    const { siteConfigReady } = useContext(ConfigContextV2);
    const { DOMAIN } = useContext(RuntimeConfigContext);

    if (loading) return <Loading wrapperClassName={styles.referral} />;

    return (
        <div className={styles.referral}>
            {slug && (
                <ErrorBoundary name={ReferralReport.name}>
                    <ReferralReportProvider domain={DOMAIN}>
                        <ReferralReport />
                    </ReferralReportProvider>
                </ErrorBoundary>
            )}
            {siteConfigReady && slug === null && (
                <ErrorBoundary name={BecomeReferral.name}>
                    <BecomeReferral
                        refetchGetAffiliate={findReferral}
                        createReferralLink={createReferralLink}
                        isPageMode={false}
                    />
                </ErrorBoundary>
            )}
        </div>
    );
};

export default AccountReferralModalContent;
